import { createRouter } from '@tanstack/react-router'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'
import { routeTree } from './routeTree.gen'
import { customQueryClient } from './react-query/config/query-client.jsx'
import { AsyncLoaderPage } from './components/async-loader/async-loader-page.jsx'

export const router = createRouter({
  routeTree,
  context: {
    queryClient: customQueryClient,
    auth: {
      user: null,
      isLoggedIn: false,
      isLoadingLogin: true,
      tokenAvailable: false
    }
  },
  scrollRestoration: true,
  defaultPreload: 'intent',
  // `autoCodeSplitting` (vite.config.js) makes every route its own chunk, so a
  // cold navigation waits on a network fetch. Without a pending component the
  // router keeps the previous screen on top for `defaultPendingMs`, which reads
  // as "the click did nothing". 150ms is below the threshold where a transition
  // stops feeling instant, so fast navigations still skip the loader entirely.
  defaultPendingComponent: AsyncLoaderPage,
  defaultPendingMs: 150,
  defaultPendingMinMs: 150
})

setupRouterSsrQueryIntegration({
  router,
  queryClient: customQueryClient
  // optional:
  // handleRedirects: true,
  // wrapQueryClient: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
